import { render, staticRenderFns } from "./ratesModal.vue?vue&type=template&id=06b4a68c&scoped=true&"
import script from "./ratesModal.vue?vue&type=script&lang=js&"
export * from "./ratesModal.vue?vue&type=script&lang=js&"
import style0 from "./ratesModal.vue?vue&type=style&index=0&id=06b4a68c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b4a68c",
  null
  
)

export default component.exports